"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesImageTypeGroupSchema = void 0;
exports.ServicesImageTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/image.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesImageTypeGroup",
    "description": "ServicesImageTypeGroup represents one of the following types: CloudinaryImage, MediabaseDeliveryAgentClips, ThingImage",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/cloudinary-image/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/thing-link/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2Uuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvdHlwZS1ncm91cHMvc2VydmljZXMvaW1hZ2Uuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsS0FBSyxFQUFFLHdFQUF3RTtJQUMvRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsYUFBYSxFQUFFLHdIQUF3SDtJQUN2SSxPQUFPLEVBQUU7UUFDUDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrR0FBa0c7U0FDM0c7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwrRUFBK0U7U0FDeEY7S0FDRjtDQUNGLENBQUEifQ==